import MessageBubble from "./MessageBubble";
import TemplateQuestions from "./TemplateQuestions";

export default function ChatMessages({
  savemessages,
  messages,
  botlogourl,
  cosui,
  show,
  questions,
  dispatch,
  handleTemplateSubmit,
  handelRetry,
}) {
  console.log("savemessages", savemessages);

  return (
    <div className="flex flex-col w-full flex-1 px-5 my-2">
      {messages?.map((msg, i) => (
        <MessageBubble
          key={msg?.key || i}
          message={msg}
          botlogourl={botlogourl}
          cosui={cosui}
          handelRetry={handelRetry}
        />
      ))}
      {savemessages?.length < 1 ||
        (messages?.length < 1 && (
          <TemplateQuestions
            show={show}
            questions={questions}
            dispatch={dispatch}
            savemessages={savemessages}
            handleTemplateSubmit={handleTemplateSubmit}
          />
        ))}
    </div>
  );
}
